var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mx-2 sdo-card overflow-auto"},[_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.previewDocument)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }